type ChatMarkedReadListener = (chatSessionId: string) => void;

const chatMarkedReadListeners = new Set<ChatMarkedReadListener>();

export function notifyChatMarkedRead(chatSessionId: string): void {
  chatMarkedReadListeners.forEach((listener) => {
    listener(chatSessionId);
  });
}

export function subscribeChatMarkedRead(listener: ChatMarkedReadListener): () => void {
  chatMarkedReadListeners.add(listener);
  return () => {
    chatMarkedReadListeners.delete(listener);
  };
}
